import script from "./VoiceSettingsFields.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceSettingsFields.vue?vue&type=script&setup=true&lang=js"

import "./VoiceSettingsFields.vue?vue&type=style&index=0&id=26e22218&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e22218"]])

export default __exports__